import { render, staticRenderFns } from "./addresource.vue?vue&type=template&id=a0269940&"
import script from "./addresource.vue?vue&type=script&lang=js&"
export * from "./addresource.vue?vue&type=script&lang=js&"
import style0 from "./addresource.vue?vue&type=style&index=0&id=a0269940&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports